// src/features/suppliers/pages/SuppliersPage.js
import React from 'react';
import MasterDataListPage from '../../master-data/pages/MasterDataListPage';

const DepartmentsPage = () => {
  return <MasterDataListPage type="departments" />;
};

export default DepartmentsPage;